import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import { get } from 'lodash';
import React from 'react';

import { PostProcessingActionCreated } from 'interfaces/postProcessingAction';
import {
  InstanceCountThresholdOption,
  INSTANCE_COUNT_THRESHOLDS_INPUT_KEY,
  isValidInstanceCountThreshold,
} from './instanceCountPositivity';

interface InstanceCountPositivityThresholdsProps {
  action: PostProcessingActionCreated;
  options: InstanceCountThresholdOption[];
  onChange: (instanceName: string, threshold?: number) => void;
}

export const InstanceCountPositivityThresholds: React.FC<InstanceCountPositivityThresholdsProps> = ({
  action,
  options,
  onChange,
}) => {
  const thresholds = get(action, INSTANCE_COUNT_THRESHOLDS_INPUT_KEY, {}) || {};

  return (
    <TableContainer component={Paper} variant="outlined" sx={{ mt: 1, maxWidth: '100%', overflowX: 'auto' }}>
      <Table size="small" aria-label="Instance positivity thresholds">
        <TableHead>
          <TableRow>
            <TableCell>RNA count column</TableCell>
            <TableCell sx={{ width: 180 }}>Count threshold</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {options.map(({ instanceName, label }) => (
            <TableRow key={instanceName}>
              <TableCell>{label}</TableCell>
              <TableCell>
                <TextField
                  fullWidth
                  required
                  size="small"
                  type="number"
                  inputProps={{ min: 0, step: 1, 'aria-label': `Count threshold for ${label}` }}
                  value={thresholds[instanceName] ?? ''}
                  error={!isValidInstanceCountThreshold(thresholds[instanceName])}
                  onChange={(event) => {
                    const threshold = event.target.value === '' ? undefined : Number(event.target.value);
                    onChange(instanceName, threshold);
                  }}
                />
              </TableCell>
            </TableRow>
          ))}
          {options.length === 0 && (
            <TableRow>
              <TableCell colSpan={2}>
                <Typography color="text.secondary" variant="body2">
                  No RNA count columns are available for the selected stains.
                </Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
